module.exports = __webpack_public_path__ + "img/frame (139).3b70bec1.jpg";